<div class="item-details">
  <div class="item-details__section">
    <div class="item-details__detail-label">Job Id:</div>
    <div class="item-details__detail">{{job.id}}</div>
    @if (job.job_created_at) {
      <div class="item-details__detail-label">Created At:</div>
      <div class="item-details__detail">{{job.displayableDate(job.job_created_at) }}</div>
    }
    <div class="item-details__detail-label">Launched By:</div>
    <div class="item-details__detail">{{job.launched_by}}</div>
  </div>

  @if (showProgress()) {
    <div class="item-details__section item-details__section--progress">
      <div class="item-details__section-heading">Progress</div>
      @if (job.job_failure_reason) {
        <div class="item-details__detail-label">Errors</div>
        <div class="item-details__detail">{{job.job_failure_reason}}</div>
      }
      @if (job.isSchedulable()) {
        <div class="item-details__detail-label">Scheduled to Run At</div>
        @if (job.status === 'idle') {
          <div class="item-details__detail">Not Yet Scheduled</div>
        }
        @if (job.status === 'scheduled') {
          <div class="item-details__detail">{{job.displayableDate(job.scheduled_at)}}</div>
        }
      }
      @if (!job.isSchedulable()) {
        <div class="item-details__detail-label">Records Validated</div>
        <div class="item-details__detail">{{job.current_validation_line}} out of {{job.total_records}}</div>
      }
      @if (showSchedule) {
        <button class="item-details__button item-details__button--schedule" (click)="schedule()">
          @if (job.status === 'scheduled') {
            Reschedule
          }
          @if (job.status === 'idle') {
            Schedule
          }
        </button>
      }
      @if (showCancel) {
        <button class="item-details__button item-details__button--cancel" (click)="cancel()">Cancel</button>
      }
    </div>
  }

  @if (showStats()) {
    <div class="item-details__section item-details__section--stats">
      <div class="item-details__section-heading">Stats</div>
      <ul class="item-details__stats-list">
        <li>Records Loaded:  <strong>{{job.total_records}}</strong></li>
        <li>Records Accepted:  <strong>{{job.records_accepted}}</strong></li>
        <li>Records Rejected:  <strong>{{job.records_rejected}}</strong></li>
        @if (job.showSmsStats()) {
          <li>Sms Attempted:  <strong>{{job.sms_attempted}}</strong></li>
          <li>Sms Not Attempted:  <strong>{{job.sms_not_attempted}}</strong></li>
        }
      </ul>
    </div>
  }

  <div class="item-details__section item-details__section--downloads">
    <div class="item-details__section-heading">Downloads</div>
    @if (noUrlsAvailable()) {
      <p>Not yet available</p>
    }
    <button class="item-details__action-button" [class.item-details__action-button--visible]="hasUrlFor('original_file')" (click)="openFile('original_file')">Original File</button>
    <button class="item-details__action-button" [class.item-details__action-button--visible]="hasUrlFor('accept_file')" (click)="openFile('accept_file')">Accept File</button>
    <button class="item-details__action-button" [class.item-details__action-button--visible]="hasUrlFor('reject_file')" (click)="openFile('reject_file')">Reject File</button>
  </div>
</div>
